import React from 'react';
import { Header, Footer, Home, DrinkList, AddRecipe } from './components'
import { Routes,Route } from 'react-router-dom';
import './App.css';


function App() {


  return (
    <div className='md:container md:mx-auto text-center flex flex-col h-screen'>
    <Header />
    
      <Routes>
        <Route exact path="/" element= {<Home/>} />
        <Route exact path="/DrinkList" element= {<DrinkList />} />      
        <Route exact path="/AddRecipe" element= {<AddRecipe />} />      
      </Routes>
    
    <Footer />
    </div>
  )
}

export default App;
